import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedProducts from './components/FeaturedProducts';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedProducts />
        <ArticlePreview />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '在线黄油',
            url: 'https://dairio.github.io',
            description: '在线黄油一站式购买平台，精选国内外优质黄油品牌，涵盖发酵黄油、无盐黄油、动物黄油等多种类型，支持在线下单、极速配送到家。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://dairio.github.io/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '在线黄油',
            url: 'https://dairio.github.io',
            description: '正品黄油在线选购平台，精选全球优质黄油，冷链直达，品质保证。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-123-4567',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '在线黄油 - 首页',
            description: '在线黄油一站式购买平台，精选国内外优质黄油品牌。',
            url: 'https://dairio.github.io/',
            isPartOf: {
              '@type': 'WebSite',
              name: '在线黄油',
              url: 'https://dairio.github.io',
            },
          }),
        }}
      />
    </>
  );
}